module.exports = __webpack_public_path__ + "static/media/downloadGreen.823d27a5.svg";